import React from 'react';
import './Payment.scss';
import ContentLoader from 'react-content-loader';
const InvoiceCard = ({
  shopifyBill,
  // downloadInvoice,
  loading,
}) => {
  const TableRow = props => {
    const random = Math.random() * (1 - 0.7) + 0.7;
    return (
      <ContentLoader
        height={40}
        width={1060}
        speed={2}
        primaryColor="#fff"
        secondaryColor="#eceef4"
        {...props}
      >
        <rect x="15" y="10" rx="4" ry="4" width="40" height="10" />
        <rect x="210" y="10" rx="4" ry="4" width={110 * random} height="10" />
        <rect x="510" y="10" rx="4" ry="4" width={200 * random} height="10" />
        <rect x="978" y="10" rx="4" ry="4" width={83 * random} height="10" />
      </ContentLoader>
    );
  };
  return (
    <div className="invoce-block mt-30">
      <div className="subheader-two-part ">
        <div className="header-sub-title header-subtitle-right ">
          <h4 className="mb-2">Subscription History</h4>
        </div>
      </div>
      <div className="clearfix"></div>
      <div className="card ph-0 pv-20">
        <table className="table tbl-middle-text tbl-header-bg tbl-th-bordernone tbl-webllist">
          <thead className="">
            <tr>
              <th className="tbl-no-col">NO.</th>
              <th>Charge ID</th>
              <th>Plan ID</th>
              <th>Billed Date</th>
            </tr>
          </thead>
          <tbody>
            {
              loading === false ?
                shopifyBill && shopifyBill.length > 0 ?
                  shopifyBill.map((b, key) => {
                    return (
                      <tr key={key}>
                        <td className="plan-invoive">{key + 1}</td>
                        <td>{b.cid ? b.cid : '-'}</td>
                        <td>{b.pi}</td>
                        <td>{b.cdt}</td>
                      </tr>
                    );
                  })
                  :
                  <tr>
                    <td colSpan="4" className="text-center" > <p className="text-center m-0">No History Found </p> </td>
                  </tr>
                :
                <tr>
                  <td colSpan='4'>
                    {
                      Array(5)
                        .fill('')
                        .map((e, i) => (
                          <TableRow key={i} style={{ opacity: Number(2 / i).toFixed(1) }} />
                        ))
                    }
                  </td>
                </tr>
            }
          </tbody>
        </table>
      </div>
    </div >
  );
};

export default InvoiceCard;


// WEBPACK FOOTER //
// ./src/components/Payment/ShopifyInvoiceCard.js